import { DaoModel } from '@dynameat/models';

export class ForecastDemandService extends DaoModel {
  constructor(guid, demand) {
    super(guid);
    this.demand = demand;
  }

  static toInstance(props = {}) {
    return new ForecastDemandService(props.guid, props.demand);
  }

  serialize() {
    return {
      ...super.serialize(),
      demand: this.demand,
    };
  }

  isInService(targetServiceGuid) {
    return this.guid === targetServiceGuid;
  }
}
